import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { FiltersData } from "../../state/AncillariesMapping/FiltersData";

const updateFiltersData: Reducer<FiltersData> = (
  state: FiltersData = new FiltersData(),
  action: Action<ActionType, FiltersData>
) => {
  switch (action.type) {
    case ActionType.ANCILLARIES_MAPPING_FILTERS_DATA_UPDATED:
      return { ...state, ...action.data };
    case ActionType.ANCILLARIES_MAPPING_FILTERS_DATA_RESET:
      return new FiltersData();
    default:
      return state;
  }
};

export default updateFiltersData;
